export default __webpack_public_path__ + "static/media/testgif.f4e5d9bc.gif";